export default class Subscription2FAInitResult {
    public nonce: string;

    public constructor(obj: any) {
        this.nonce = obj.nonce;
    }
}